// extracted by mini-css-extract-plugin
export var attachment = "_oa-a";
export var emailContainer = "_oa-4";
export var emailContentPaddedContainer = "_oa-b";
export var emailHeader = "_oa-6";
export var emailIframe = "_oa-3";
export var emailInfoIcon = "_oa-9";
export var emailShortenedSummary = "_oa-e";
export var infoDropdown = "_oa-0";
export var infoRowBoundedContent = "_oa-d";
export var internal = "_oa-5";
export var merchant = "_oa-8";
export var messageInputContainer = "_oa-h";
export var normal = "_oa-7";
export var replyCard = "_oa-f";
export var subtleButton = "_oa-1";
export var subtleButtonIconContainer = "_oa-2";
export var toggleViewRepliesButton = "_oa-c";
export var wrappingText = "_oa-g";